/**
 * Menu & Bar Update Functions
 *
 * Functions that render/update the main menu, clue bar,
 * solution bar, and history bar.
 */

import { appState } from '../state/AppState';
import { session } from './puzzleSession';

/**
 * Update the main menu display
 */
export function updateMainMenu(): void {
    if (!session.mainMenu || !session.currentPuzzle) return;

    const menuEl = document.getElementById('rejtveny_menusor');
    if (menuEl) {
        menuEl.innerHTML = session.mainMenu.render();

        // Attach events only once
        if (!session.menuEventsAttached) {
            session.mainMenu.attachEvents(menuEl);
            session.menuEventsAttached = true;
        }
    }
}

/**
 * Update the clue/definition bar
 */
export function updateClueBar(): void {
    if (!session.clueMenu || !session.currentPuzzle) return;

    // Always update the header expression display (rejtveny_fejlec)
    // Legacy: Menu.toString() calls updateKijeloltKifejezes() unconditionally in both modes
    session.clueMenu.updateCells();
    session.clueMenu.updateSelectedExpression();

    // Legacy: clue bar (rejtveny_meghatarozassav) only shown in builder mode (g_epitoMod check)
    if (!appState.isBuilderMode) return;

    const clueEl = document.getElementById('rejtveny_meghatarozassav');
    if (clueEl) {
        clueEl.innerHTML = session.clueMenu.toString();
    }
}

/**
 * Update the solution bar
 */
export function updateSolutionBar(): void {
    if (!session.solutionMenu || !session.currentPuzzle) return;

    const solutionEl = document.getElementById('rejtveny_megoldassav');
    if (solutionEl) {
        solutionEl.innerHTML = session.solutionMenu.toString();
    }
}

/**
 * Update the history bar
 */
export function updateHistoryBar(): void {
    if (!session.historyManager) return;

    const historyEl = document.getElementById('rejtveny_elozmenysav');
    if (historyEl) {
        historyEl.innerHTML = session.historyManager.toHtml();
    }
}
